import React from 'react';
import { getPartner } from '../../config/partners';

/**
 * @param {{ partnerId?: string, variant?: 'primary' | 'compact' }} props
 */
function PartnerTip({ partnerId = 'onePassword', variant = 'primary' }) {
  const partner = getPartner(partnerId);
  if (!partner) return null;

  const isPrimary = variant === 'primary';
  const url = partner.url;

  return (
    <aside
      className={
        isPrimary
          ? 'my-8 p-6 bg-indigo-50 border border-indigo-100 rounded-lg'
          : 'my-6 p-4 bg-gray-50 border border-gray-200 rounded-lg'
      }
      aria-label={`About ${partner.name}`}
    >
      <p className="text-sm font-semibold text-indigo-900 uppercase tracking-wide">
        Recommended tool
      </p>
      <h3 className={`font-bold text-gray-900 ${isPrimary ? 'text-xl mt-1' : 'text-lg mt-1'}`}>
        {partner.name}
      </h3>
      <p className={`text-gray-700 ${isPrimary ? 'mt-2' : 'mt-1 text-sm'}`}>{partner.blurb}</p>
      {url ? (
        <a
          href={url}
          target="_blank"
          rel="noopener noreferrer sponsored"
          className="inline-block mt-4 px-4 py-2 bg-indigo-600 text-white rounded hover:bg-indigo-700 text-sm font-medium"
        >
          Learn about {partner.name}
        </a>
      ) : null}
    </aside>
  );
}

export default PartnerTip;
